import React from "react";

import { string, arrayOf, shape } from "prop-types";
import { Link } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";

import "./StoryAuthors.m.css";
import { getCategoryAndSubCategory, getTemplateName } from "../../../ga-utils";

const StoryAuthors = ({ storyAuthor, customStyleName, story, config, pageType }) => {
  const qtState = useSelector((state) => state);
  const isWebView = get(qtState, ["qt", "config", "isWebView"]) === true;
  let isWebViewQuery = "";
  if (isWebView) {
    isWebViewQuery = "?webview=true";
  }
  const handleAuthorInteraction = (author, url) => {
    const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, config, story);
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_story_interactions",
        event_action: "author_click",
        link_url: url,
        link_text: author?.name,
        category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(story?.["story-template"] || pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  return (
    <div styleName={customStyleName} className="authors">
      {storyAuthor?.map((author, index) => {
        const isLastIndex = index < storyAuthor.length - 1;
        const authorUrl = `/author/${author?.slug}${isWebViewQuery}`;
        return (
          <Link
            styleName="link"
            href={authorUrl}
            key={`${author?.slug}-${index}`}
            disableAjaxLinks={true}
            onTouchStart={() => handleAuthorInteraction(author, authorUrl)}
            onMouseDown={() => handleAuthorInteraction(author, authorUrl)}
          >
            {`${author?.name}${isLastIndex ? ", " : ""}`}
          </Link>
        );
      })}
    </div>
  );
};

StoryAuthors.defaultProps = {
  storyAuthor: [],
  customStyleName: "",
};

StoryAuthors.propTypes = {
  storyAuthor: arrayOf(
    shape({
      slug: string,
    })
  ).isRequired,
  customStyleName: string.isRequired,
};

export default StoryAuthors;
